// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#viewButton {\n  margin-left: 4%;\n}", "",{"version":3,"sources":["webpack://src/pages/Students/Students.scss"],"names":[],"mappings":"AAEA;EAEI,eAAA;AAFJ","sourcesContent":["// Variables\n@import \"../../assets/css/vars\";\n#viewButton{\n   // padding-right: 50%;\n    margin-left: 4%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
